export const modeMap = {
  "Person Detection": { mode: "person" },
  "Bicycle Detection": { mode: "bicycle" },
  "Car Detection": { mode: "car" },
  "Motorcycle Detection": { mode: "motorcycle" },
  "Airplane Detection": { mode: "airplane" },
  "Bus Detection": { mode: "bus" },
  "Train Detection": { mode: "train" },
  "Truck Detection": { mode: "truck" },
  "Boat Detection": { mode: "boat" },
  "Traffic Light Detection": { mode: "traffic_light" },
  "Fire Hydrant Detection": { mode: "fire_hydrant" },
  "Stop Sign Detection": { mode: "stop_sign" },
  "Parking Meter Detection": { mode: "parking_meter" },
  "Bench Detection": { mode: "bench" },
  "Bird Detection": { mode: "bird" },
  "Cat Detection": { mode: "cat" },
  "Dog Detection": { mode: "dog" },
  "Horse Detection": { mode: "horse" },
  "Sheep Detection": { mode: "sheep" },
  "Cow Detection": { mode: "cow" },
  "Elephant Detection": { mode: "elephant" },
  "Bear Detection": { mode: "bear" },
  "Zebra Detection": { mode: "zebra" },
  "Giraffe Detection": { mode: "giraffe" },
  "Backpack Detection": { mode: "backpack" },
  "Umbrella Detection": { mode: "umbrella" },
  "Handbag Detection": { mode: "handbag" },
  "Tie Detection": { mode: "tie" },
  "Suitcase Detection": { mode: "suitcase" },
  "Frisbee Detection": { mode: "frisbee" },
  "Skis Detection": { mode: "skis" },
  "Snowboard Detection": { mode: "snowboard" },
  "Sports Ball Detection": { mode: "sports_ball" },
  "Kite Detection": { mode: "kite" },
  "Baseball Bat Detection": { mode: "baseball_bat" },
  "Baseball Glove Detection": { mode: "baseball_glove" },
  "Skateboard Detection": { mode: "skateboard" },
  "Surfboard Detection": { mode: "surfboard" },
  "Tennis Racket Detection": { mode: "tennis_racket" },
  "Bottle Detection": { mode: "bottle" },
  "Wine Glass Detection": { mode: "wine_glass" },
  "Cup Detection": { mode: "cup" },
  "Fork Detection": { mode: "fork" },
  "Knife Detection": { mode: "knife" },
  "Spoon Detection": { mode: "spoon" },
  "Bowl Detection": { mode: "bowl" },
  "Banana Detection": { mode: "banana" },
  "Apple Detection": { mode: "apple" },
  "Sandwich Detection": { mode: "sandwich" },
  "Orange Detection": { mode: "orange" },
  "Broccoli Detection": { mode: "broccoli" },
  "Carrot Detection": { mode: "carrot" },
  "Hot Dog Detection": { mode: "hot_dog" },
  "Pizza Detection": { mode: "pizza" },
  "Donut Detection": { mode: "donut" },
  "Cake Detection": { mode: "cake" },
  "Chair Detection": { mode: "chair" },
  "Couch Detection": { mode: "couch" },
  "Potted Plant Detection": { mode: "potted_plant" },
  "Bed Detection": { mode: "bed" },
  "Dining Table Detection": { mode: "dining_table" },
  "Toilet Detection": { mode: "toilet" },
  "TV Detection": { mode: "tv" },
  "Laptop Detection": { mode: "laptop" },
  "Mouse Detection": { mode: "mouse" },
  "Remote Detection": { mode: "remote" },
  "Keyboard Detection": { mode: "keyboard" },
  "Cell Phone Detection": { mode: "cell_phone" },
  "Microwave Detection": { mode: "microwave" },
  "Oven Detection": { mode: "oven" },
  "Toaster Detection": { mode: "toaster" },
  "Sink Detection": { mode: "sink" },
  "Refrigerator Detection": { mode: "refrigerator" },
  "Book Detection": { mode: "book" },
  "Clock Detection": { mode: "clock" },
  "Vase Detection": { mode: "vase" },
  "Scissors Detection": { mode: "scissors" },
  "Teddy Bear Detection": { mode: "teddy_bear" },
  "Hair Drier Detection": { mode: "hair_drier" },
  "Toothbrush Detection": { mode: "toothbrush" },

  // Your custom modes (kept as is)
  "Phone Detection": { mode: "mobile" },
  "Phone Usage": { mode: "mobile" },
  "Vehicle Detection": { mode: "vehicle" },
  "Overcrowd": { mode: "overcrowd", params: { max_count: 12 } },
  "Intrusion": { mode: "intrusion" },
  "Parking": { mode: "parking", params: { total_spaces: 18 } },
  "Object Left": { mode: "object_left" },
  "Fall Detection": { mode: "fall_detection" },
  "Social Distance": { mode: "social_distance", params: { min_distance: 80 } },
};